export default __webpack_public_path__ + "static/media/Reactjs.86c8d9eb.png";